mainApp.component('monitorOffcloudSiteRow', {
    templateUrl: '/public/components/realtime/monitor-offcloud-site-row.component.html',
    bindings: {
        siteData: '<',
        selectRow: '&',
        selectedRow: '<',
    },
    controller: function ($scope) {
        let ctrl = this;

        ctrl.expandable = false;

        ctrl.$onChanges = (changes) => {
            ctrl.tableData = [];
            ctrl.expandable = Object.keys(ctrl.siteData.perTunnelQuality).length > 0;
            if (ctrl.expandable) {
                for (let tunnelIdentifier in ctrl.siteData.perTunnelQuality) {
                    ctrl.tableData.push({...ctrl.siteData.perTunnelQuality[tunnelIdentifier], ...{siteName: tunnelIdentifierToPeerName(tunnelIdentifier), protoId: tunnelIdentifier}});
                }
                ctrl.tableData.sort((a,b) => {
                    return (a.protoId > b.protoId) ? 1 : ((b.protoId > a.protoId) ? -1 : 0);
                });
            }

        };

        ctrl.siteRowClicked = () => {
            ctrl.selectRow({site: ctrl.siteData});
        };

        ctrl.tunnelRowClicked = (tunnel) => {
            ctrl.selectRow({site: ctrl.siteData, tunnel: tunnel});
        };

        //takes "(WAN1,WAN2)" string and makes "Local WAN1 - Peer WAN2" from it.
        let tunnelIdentifierToPeerName = (tunnelIdentifier) => {
            tunnelIdentifier = tunnelIdentifier.substring(1, tunnelIdentifier.length - 1); // get rid of parenthesis
            let local, peer;
            [local, peer] = tunnelIdentifier.split(","); //destructuring assignment! how cool is it?! 😱
            return `Local ${local} - Peer ${peer}`;
        };

        ctrl.expandIconClicked = ($event) => {
            ctrl.siteData.expanded ? ctrl.siteData.expanded = false : ctrl.siteData.expanded = true;
            $event.stopPropagation();
        };

    }

});